import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import qs from "qs";
import { ApiConstant, AppConstant } from "const";
import { ApiUtils, HumpUtils, SystemUtils } from "utils";

export default function useUpdateChannelMemberRole() {
  const { t: getLabel } = useTranslation();

  const mutation = useMutation({
    mutationFn: async ({ groupId, memberId, memberInviteType }) => {
      const payload = qs.stringify(HumpUtils.decamelizeKeys({ groupId, memberId, memberInviteType }));
      const response = await ApiUtils.createApiWithToken(false).post(ApiConstant.POST_UPDATE_CONVERSATION, payload);
      return HumpUtils.camelizeKeys(response.data);
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async (response, { groupId, memberInviteType, onResetMembers, onSuccess }) => {
      if ([ApiConstant.STT_OK, ApiConstant.STT_CREATED].includes(response?.status)) {
        const isGrant = memberInviteType === AppConstant.CHANNEL_MEMBER_TYPE.admin;
        SystemUtils.appendNotification(
          getLabel(isGrant ? "TXT_GRANT_CHANNEL_ADMIN_SUCCESS" : "TXT_REVOKE_CHANNEL_ADMIN_SUCCESS"),
          "success",
        );
        await onResetMembers?.();
        onSuccess?.();
      } else if (response.status === ApiConstant.STT_BAD_REQUEST) {
        SystemUtils.appendNotification(getLabel("TXT_MEMBER_NOT_EXISTED"), "error");
        await onResetMembers?.();
        onSuccess?.();
      } else {
        const isGrant = memberInviteType === AppConstant.CHANNEL_MEMBER_TYPE.admin;
        SystemUtils.appendNotification(
          getLabel(isGrant ? "TXT_GRANT_CHANNEL_ADMIN_FAIL" : "TXT_REVOKE_CHANNEL_ADMIN_FAIL"),
          "error",
        );
      }
    },
    onError: () => {
      SystemUtils.appendNotification(getLabel("TXT_TIMEOUT"), "error");
    },
  });

  /** Grant admin role to a member */
  const grantAdmin = ({ groupId, memberId, onResetMembers, onSuccess }) => {
    mutation.mutate({
      groupId,
      memberId,
      memberInviteType: AppConstant.CHANNEL_MEMBER_TYPE.admin,
      onResetMembers,
      onSuccess,
    });
  };

  /** Revoke admin role from a member */
  const revokeAdmin = ({ groupId, memberId, onResetMembers, onSuccess }) => {
    mutation.mutate({
      groupId,
      memberId,
      memberInviteType: AppConstant.CHANNEL_MEMBER_TYPE.member,
      onResetMembers,
      onSuccess,
    });
  };

  return { grantAdmin, revokeAdmin, isLoading: mutation.isLoading };
}
